import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M8.4653 13.7382C8.23213 13.9683 8.07605 14 8 14C7.92395 14 7.76787 13.9683 7.5347 13.7382C7.29723 13.5038 7.03751 13.1151 6.79782 12.5558C6.36399 11.5435 6.06028 10.1232 6.00802 8.5H9.99198C9.93972 10.1232 9.63601 11.5435 9.20218 12.5558C8.96249 13.1151 8.70277 13.5038 8.4653 13.7382ZM9.99198 7.5H6.00802C6.06028 5.87683 6.36399 4.45646 6.79782 3.44417C7.03751 2.8849 7.29723 2.4962 7.5347 2.26184C7.76787 2.03173 7.92395 2 8 2C8.07605 2 8.23213 2.03173 8.4653 2.26184C8.70277 2.4962 8.96249 2.8849 9.20218 3.44417C9.63601 4.45646 9.93972 5.87683 9.99198 7.5ZM10.9925 8.5C10.9266 10.6763 10.4344 12.578 9.7096 13.7529C12.0368 13.0624 13.7734 10.9982 13.9795 8.5H10.9925ZM13.9795 7.5H10.9925C10.9266 5.32368 10.4344 3.42203 9.7096 2.24707C12.0368 2.93761 13.7734 5.00183 13.9795 7.5ZM5.00753 7.5C5.07336 5.32368 5.56556 3.42203 6.2904 2.24707C3.96316 2.93761 2.22663 5.00183 2.02054 7.5H5.00753ZM2.02054 8.5C2.22663 10.9982 3.96316 13.0624 6.2904 13.7529C5.56556 12.578 5.07336 10.6763 5.00753 8.5H2.02054ZM15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
